import { useLang } from "@/i18n/LanguageContext";
import { Link } from "react-router-dom";
import HtmlText from "@/components/HtmlText";
import SmartImage from "@/components/SmartImage";
import FreshBadge from "@/components/FreshBadge";
import { articlePath } from "@/lib/radarPaths";

const NewsCard = ({ item, idx = 0, layout = "vertical" }) => {
  const { t, lang } = useLang();
  const horizontal = layout === "horizontal";
  const to = articlePath("news", item);

  return (
    <article
      data-testid={`news-card-${idx}`}
      className={`group bg-white border border-[#E5E7EB] hover:border-[#111827] transition-colors flex ${
        horizontal ? "flex-row gap-4 p-3" : "flex-col"
      }`}
    >
      <Link
        to={to}
        data-testid={`news-image-${idx}`}
        className={`relative overflow-hidden bg-[#F3F4F6] block shrink-0 ${
          horizontal ? "w-32 sm:w-40 aspect-[4/3]" : "aspect-[16/9] max-h-44"
        }`}
      >
        <SmartImage
          entity={item}
          type="news"
          alt={item.title || "News article"}
          className="w-full h-full transition-transform duration-500 group-hover:scale-105"
        />
        {!horizontal && (
          <span className={`absolute top-2 left-2 px-2 py-0.5 text-[10px] font-mono-dl tracking-wider uppercase impact-${item.impact_level}`}>
            {t.impact[item.impact_level] || item.impact_level}
          </span>
        )}
      </Link>
      <div className={`flex flex-col flex-1 ${horizontal ? "" : "p-4"}`}>
        <div className="flex items-center gap-2 text-[10px] font-mono-dl tracking-wider uppercase text-[#4B5563]">
          {item.relevance_area && <span className="text-[#00A878]">{item.relevance_area}</span>}
          <span className="text-[#9ca3af]">·</span>
          <span>{item.published_at}</span>
          <FreshBadge publishedAt={item.published_at} createdAt={item.created_at} lang={lang} />
          {horizontal && (
            <span className={`ml-auto px-1.5 py-0.5 text-[9px] impact-${item.impact_level}`}>
              {t.impact[item.impact_level] || item.impact_level}
            </span>
          )}
        </div>
        <h3 className={`font-display ${horizontal ? "text-[16px]" : "text-lg sm:text-xl"} leading-snug text-[#111827] mt-1.5`}>
          <Link
            to={to}
            data-testid={`news-title-${idx}`}
            className="group-hover:text-[#00A878] transition-colors"
          >
            {item.title}
          </Link>
        </h3>
        {!horizontal && (
          <HtmlText html={item.summary} className="text-[14px] leading-relaxed text-[#4B5563] mt-2 line-clamp-3" />
        )}
        {item.dataleo_angle && !horizontal && (
          <div className="mt-3 border-l-2 border-[#00A878] pl-3">
            <div className="text-[10px] font-mono-dl tracking-wider uppercase text-[#00A878]">{t.labels.dataleoAngle}</div>
            <HtmlText html={item.dataleo_angle} className="text-[13px] text-[#111827] mt-0.5 line-clamp-2" />
          </div>
        )}
        <div className="flex items-center gap-2 mt-auto pt-3 text-[11px] font-mono-dl text-[#4B5563] uppercase tracking-wider">
          <span>{item.source}</span>
        </div>
      </div>
    </article>
  );
};

export default NewsCard;
